/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import { getWorkerList, getAllUserList } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    check: {
      type: Boolean,
      default: false
    },
    showService: {
      type: Boolean,
      default: false
    },
    // 显示协同人 根据传入的list
    showCollabPeople: {
      type: Boolean,
      default: false
    },
    colist: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ccList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    size: {
      type: String,
      default: 'mini'
    },
    type: {
      type: String,
      default: 'user'
      /*
        user: 用户
        ccUser: 抄送给我
      */

    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      list: [],
      checkList: [],
      ids: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;

      if (val) {
        this.resetList(); // 抄送给我列表 回显

        if (this.type === 'ccUser') {
          var checkList = this.ccList || [];
          this.ids = checkList.map(function (item) {
            return {
              value: item.cc_user_id,
              name: item.NAME,
              imgUrl: item.avatar
            };
          });
        }
      }
    },
    currValue: function currValue(val) {
      var _this = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
        if (this.check) this.$refs.workerList.clearCheckList();
      }

      this.$emit('input', val);
    }
  },
  methods: {
    loadList: function loadList(op) {
      var _this2 = this;

      if (this.showCollabPeople) {
        this.list = this.colist;
        return;
      }

      var data = {
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        keyword: this.keyword,
        state: 1
      };
      this.loadwhichList(data).then(function (res) {
        if (op === 'search') {
          _this2.list = [];
        }

        _this2.$refs['workerList'] && _this2.$refs['workerList'].donePullup();
        _this2.$refs['workerList'] && _this2.$refs['workerList'].donePulldown();

        if (res.success) {
          _this2.list = _this2.list.concat(res.data);

          if (res.data.length < _this2.pageSize) {
            _this2.$refs['workerList'] && _this2.$refs['workerList'].disablePullup();
          }
        } else {// 暂缺
        }
      });
    },
    loadwhichList: function loadwhichList(data) {
      if (this.showService) {
        return getWorkerList(_objectSpread({
          roleId: 2
        }, data)); // 加载服务人员
      } else {
        return getAllUserList(data); // 加载全部用户
      }
    },
    resetList: function resetList() {
      this.list = [];
      this.pageIndex = 0;
      this.$refs['workerList'] && this.$refs['workerList'].enablePullup();
      this.loadList('search');
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    // 多选确认
    onCheckOk: function onCheckOk(ids) {
      this.currValue = false;
      var list = this.list.filter(function (item) {
        return ids.indexOf(item.id) !== -1;
      });
      var names = list.map(function (item) {
        return item.name;
      });
      this.$emit('on-ok', ids, names, list);
    },
    // 单选
    onRadioOk: function onRadioOk(data) {
      if (!this.check) {
        this.currValue = false;
        this.$emit('on-ok', data);
      }
    }
  },
  created: function created() {// this.loadList()
  }
};